import * as moment from 'moment';

export function formatAddress(addressLine: string, city: string | null, country: string | null, state: string | null, zip: string | null) {
    let address = addressLine;
    if (city != null && city.length > 0) {
        address += ', ' + city;
    }
    if (country != null && country.length > 0) {
        address += ', ' + country;
    }
    if (state != null && state.length > 0) {
        address += ', ' + state;
    }
    if (zip != null && zip.length > 0) {
        address += ' ' + zip;
    }

    return address;
}

export function getCurrentDate() {
    var currentDate = new Date();
    return currentDate;
}

/*
* This function is used to convert string format yyyy/MM/dd HH:mm:ss to javascipt Date format
*/
export function convertStringToDate(stringFormat: string | null) {
    if (stringFormat != null) {
        // tslint:disable-next-line:variable-name
        var acDateTime_Regex = /^\d{4}\/\d{2}\/\d{2}\s\d{2}\:\d{2}\:\d{2}$/;

        if (acDateTime_Regex.test(stringFormat)) {
            var dateFormat = new Date(stringFormat);

            if (!isNaN(dateFormat.getTime())) {
                return dateFormat;
            }
        }
    }

    return null;
}

/*
* This function is used to convert javascipt Date format to string format yyyy/MM/dd HH:mm:ss 
*/
export function convertDateToString(dateFormat: Date | null) {
    if (dateFormat != null && !isNaN(dateFormat.getTime())) {
        var yyyy = dateFormat.getFullYear();
        var MM = dateFormat.getMonth() + 1;
        var dd = dateFormat.getDate();

        var HH = dateFormat.getHours() < 10 ? '0' + dateFormat.getHours() : dateFormat.getHours();
        var mm = dateFormat.getMinutes() < 10 ? '0' + dateFormat.getMinutes() : dateFormat.getMinutes();
        var ss = dateFormat.getSeconds() < 10 ? '0' + dateFormat.getSeconds() : dateFormat.getSeconds();

        return yyyy + '/' + MM + '/' + dd + ' ' + HH + ':' + mm + ':' + ss;
    }

    return null;
}

/*
* This function is used to convert date to easy-reading format MM/dd/yyyy.
* Used in client only. Do not send date under this format to server
*/
export function formatDateMDY(dateFormat: Date | null | undefined) {
    if (dateFormat != null && dateFormat != undefined && !isNaN(dateFormat.getTime())) {
        var yyyy = dateFormat.getFullYear();
        var MM = (dateFormat.getMonth() + 1) < 10 ? '0' + (dateFormat.getMonth() + 1) : (dateFormat.getMonth() + 1);
        var dd = dateFormat.getDate() < 10 ? '0' + dateFormat.getDate() : dateFormat.getDate();

        return MM + '/' + dd + '/' + yyyy;
    }

    return '';
}

/*
* This function is used to convert date to easy-reading format MM/dd/yyyy HH:mm AM/PM.
* Used in client only. Do not send date under this format to server
*/
export function formatDateMDYHMAP(dateFormat: Date | null) {
    if (dateFormat != null && !isNaN(dateFormat.getTime())) {
        var yyyy = dateFormat.getFullYear();
        var MM = (dateFormat.getMonth() + 1) < 10 ? '0' + (dateFormat.getMonth() + 1) : (dateFormat.getMonth() + 1);
        var dd = dateFormat.getDate() < 10 ? '0' + dateFormat.getDate() : dateFormat.getDate();

        var hour = dateFormat.getHours();
        hour = hour % 12;
        hour = hour ? hour : 12;
        var HH = hour < 10 ? '0' + hour : hour;
        var mm = dateFormat.getMinutes() < 10 ? '0' + dateFormat.getMinutes() : dateFormat.getMinutes();

        var ampm = dateFormat.getHours() >= 12 ? 'PM' : 'AM';

        return MM + '/' + dd + '/' + yyyy + ' ' + HH + ':' + mm + ' ' + ampm;
    }

    return null;
}

/* dob's format must be YYYY-MM-DD */
export function formatDateFromServer(date: string | undefined) {
    return moment(date, 'YYYY-MM-DD').isValid() ? moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY') : '';
}

export function formatDateMDYHMAPFromServer(date: string | undefined) {
    return moment(date, 'YYYY-MM-DDTHH:mm:sszzz').isValid() ? moment(date, 'YYYY-MM-DDTHH:mm:sszzz').format('MM/DD/YYYY hh:mm A') : '';
}

/* dob's format is sent to server must be YYYY-MM-DD */
export function parseDateToSendToServer(date: string) {
    return moment(date, 'MM/DD/YYYY').isValid() ? moment(date, 'MM/DD/YYYY').format('YYYY-MM-DD') : '';
}

/* exam date's format must be YYYY/MM/DD hh:mm:ss */
export function formatExamDate(examDate: string) {
    return moment(examDate, 'YYYY/MM/DD hh:mm:ss').format('MM/DD/YYYY hh:mm A');
}

export function formatSmallValue(val: string) {
    var checkIsSmall = new RegExp('e-{1}[0-9]$');

    if (checkIsSmall.test(val)) {
        return Number(val).toFixed(9).replace(/\.?0+$/, '');
    }

    return val;
}

export function formatDaySupply(daySupply: number) {
    return daySupply !== 0 ? daySupply.toString() : '';
}

export function isJSONString(value: string): boolean {
    try {
        if (value) {
            JSON.parse(value);
            return true;
        }
        return false;
    } catch (e) {
        return false;
    }
}

export function isStringHasMultipleLines(x: string): boolean {
    return (((x || '').match(new RegExp('<(p|li)>', 'gi')) || []).length > 1);
}

export function removeEmptyLines(x: string): string {
    return x.replace(new RegExp('<p><br></p>', 'g'), '');
}

/* 
* SSN number 
*/
export function ssnFormat(ssn: string) {
    ssn = ssn.slice(0, 11).replace(/-/g, '');
    if (ssn.length <= 3) {
        return ssn;
    }
    if (ssn.length > 3 && ssn.length <= 5) {
        return `${ssn.slice(0, 3)}-${ssn.slice(3)}`;
    }
    if (ssn.length > 5) {
        return `${ssn.slice(0, 3)}-${ssn.slice(3, 5)}-${ssn.slice(5)}`;
    }
    return ssn;
}

export function ssnMask(ssn: string, hideSSN: boolean): string {
    if (!hideSSN) {
        return ssn;
    }

    const masked = ssn.slice(0, 7).replace(/[0-9]/g, '*');
    const final = masked + ssn.slice(7);
    return final;
}

export function formatAndMaskSSN(rawSSN: string, hideSSN: boolean): string {
    return ssnMask(ssnFormat(rawSSN), hideSSN);
}

export function isEmpty(value: any): boolean {
    return value == null // NULL value
        || value == undefined // undefined
        || value == 'undefined' // undefined
        || value.length == 0 // Array is empty
        || value == '00000000-0000-0000-0000-000000000000' // Guid empty
        || ((value instanceof Date && !isNaN(value.valueOf())) // Validate DateTime value and check min-max value
            && ((value <= new Date(1753, 1, 1)) // SQL DateTime minimum value
                || (value >= new Date(9999, 12, 31, 23, 59, 59, 999))) // SQL DateTime maximum value
        );
}

export function isNullOrEmpty(value: string | undefined): boolean {
    return value === null // NULL value
        || value === undefined // undefined
        || typeof (value) === 'undefined' // undefined
        || value === ''; // empty
}


// WEBPACK FOOTER //
// ./src/utils/formater.ts